module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-228.2995756b.jpg";